// extracted by mini-css-extract-plugin
export default {"about":"about_about__k62nO","container":"about_container__HgPr5","item":"about_item__73n7Z","text":"about_text__gogfX","title":"about_title__Pja3M","hidden":"about_hidden__+PjrG"};